export default __webpack_public_path__ + "static/media/GroupRemove.a0432413.svg";